export default {
  customergroups(state) {
    return state.customergroups
  },
}
